// constants
import { PatientActionTypes } from './constants';
import { Patient as PatientDataType } from 'src/types/patient';

export type PatientActionType = {
    type:
        | PatientActionTypes.API_RESPONSE_SUCCESS
        | PatientActionTypes.API_RESPONSE_ERROR
        | PatientActionTypes.GET_PATIENT
        | PatientActionTypes.ADD_PATIENT
        | PatientActionTypes.EDIT_PATIENT
        | PatientActionTypes.GET_PATIENTS
        | PatientActionTypes.GET_VALIDATE_PATIENT
        | PatientActionTypes.RESET
        | PatientActionTypes.RESET_SUCCESS
        | PatientActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const patientApiResponseSuccess = (
    actionType: string,
    data: PatientDataType[] | PatientDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PatientActionType => ({
    type: PatientActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const patientApiResponseError = (
    actionType: string,
    data: PatientDataType[] | PatientDataType | [] | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PatientActionType => ({
    type: PatientActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addPatient = (params: any): PatientActionType => ({
    type: PatientActionTypes.ADD_PATIENT,
    payload: params,
});

export const editPatient = (params: any): PatientActionType => ({
    type: PatientActionTypes.EDIT_PATIENT,
    payload: params,
});

export const getPatient = (params: any): PatientActionType => ({
    type: PatientActionTypes.GET_PATIENT,
    payload: params,
});

export const getPatients = (params: any): PatientActionType => ({
    type: PatientActionTypes.GET_PATIENTS,
    payload: params,
});

export const getValidatePatient = (params: any): PatientActionType => ({
    type: PatientActionTypes.GET_VALIDATE_PATIENT,
    payload: params,
});

export const resetPatient = (): PatientActionType => ({
    type: PatientActionTypes.RESET,
    payload: {},
});

export const resetPatientSuccess = (): PatientActionType => ({
    type: PatientActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetPatientError = (): PatientActionType => ({
    type: PatientActionTypes.RESET_ERROR,
    payload: {},
});
